import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { computed, action } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import withAppStore from 'decorators/withAppStore'
import formField from 'helpers/formField'
import inject from 'helpers/inject'

import Dialog, { DialogActions, DialogContent, DialogTitle } from 'material-ui/Dialog'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import FormInput from 'components/forms/FormInput'
import AsyncButton from 'components/AsyncButton'
import TextField from 'material-ui/TextField'

import RouterService from 'services/router'

import updateApiKey from 'tasks/updateApiKey'

import styles from 'styles/components/EditKeyModal'

@withStyles(styles)
@withAppStore
@observer
export default class EditKeyModal extends Component {

  static propTypes = {
    apiKey: PropTypes.object
  }

  router = inject(RouterService)

  @computed
  get key() {
    return this.props.apiKey
  }

  @computed
  get domainsList() {
    return formField({
      value: this.key.domains,
      label: 'Список доменов',
      name: 'domains',
      validations: {
        presence: true
      }
    })
  }

  @computed
  get isOpen() {
    return !!this.key
  }

  render() {
    const { classes } = this.props

    return (
      <Dialog
        open={ this.isOpen }
        onClose={ this.handleClose }
      >
        { this.isOpen &&
          <Fragment>
            <DialogTitle>Редактирование ключа</DialogTitle>
            <DialogContent>
              <Fragment>
                <TextField
                  disabled
                  value={ this.key.key }
                  label="Ключ"
                  fullWidth
                />
                <Typography paragraph type='caption' >
                  Вы можете изменить список доменов для ключа. Можно указать несколько доменов, разделяя их запятыми
                </Typography>
                <FormInput
                  field={ this.domainsList }
                  TextFieldProps={{
                    fullWidth: true
                  }}
                />
              </Fragment>
            </DialogContent>
            <DialogActions className={ classes.actions }>
              <Button onClick={ this.handleClose } color="primary" >
                Закрыть
              </Button>
              <AsyncButton
                action={ this.handleSave }
                ButtonProps={{
                  raised: true,
                  color: 'primary'
                }}
              />
            </DialogActions>
          </Fragment>
        }
      </Dialog>
    )
  }

  @action.bound
  handleClose() {
    this.router.transitionTo(`/keys/${this.key.id}`)
  }

  @action.bound
  async handleSave() {
    this.domainsList.validate()
    if (this.domainsList.hasErrors) throw new Error()
    this.key.domains = this.domainsList.value
    await updateApiKey.perform(this.key)
  }

}



// WEBPACK FOOTER //
// ./src/components/EditKeyModal.js